module.exports = __webpack_public_path__ + "static/media/view_subject_discipline.9cce850b.svg";